import React from "react";

const Java_Reference = () => {
  return (
    <div>
      <h1>Java Reference</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Reference in Java.</p>
    </div>
  );
};

export default Java_Reference;
